export type RxPdpAppPlacement = 'buy-box' | 'drawer'

export const RX_PDP_APP_VIEWPORT_URL =
  'https://shop-apotheke-com.onelink.me/d95Q/rx-pdp-test_viewport'
export const RX_PDP_APP_DRAWER_URL =
  'https://shop-apotheke-com.onelink.me/d95Q/rx-pdp-test-drawer'
